import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as RemoveIcon } from 'images/cancel-24.svg';
import styles from 'modules/Profile/components/FamilyAccess/FamilyAccess.module.scss';
import { ReactComponent as ErrorIcon } from 'images/error_outline-24px.svg';
import Modal from 'components/Modal';
import Tooltip from 'components/Tooltip';
import Button, { BUTTON_COLORS } from 'components/Button';

const GuardianActions = ({
  columnProps: {
    rest: { inn, active, terminationReason, relationAvailable, onRemove },
  },
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const onRemoveItem = useCallback(() => {
    onRemove({ inn });
    setModalVisible(false);
  }, [inn, onRemove]);

  if (active && !relationAvailable) {
    return <ErrorIcon className={styles.errorIcon} />;
  }

  if (active) {
    return (
      <>
        <RemoveIcon className={styles.removeIcon} onClick={() => setModalVisible(true)} />
        <Modal showModal={modalVisible} onClose={() => setModalVisible(false)}>
          <h2>Прекращение доступа</h2>
          <p>
            Даю согласие на прекращение доступа у законного представителя (родителя) к информации из
            моего Личного кабинета налогоплательщика
          </p>
          <div className={styles.actions}>
            <Button
              extraClassName={styles.button}
              color={BUTTON_COLORS.WHITE_BLUE}
              hasWrapper={false}
              onClick={() => setModalVisible(false)}
            >
              Отменить
            </Button>
            <Button
              extraClassName={styles.button}
              color={BUTTON_COLORS.ORANGE}
              hasWrapper={false}
              onClick={onRemoveItem}
            >
              Удалить
            </Button>
          </div>
        </Modal>
      </>
    );
  }

  return terminationReason ? (
    <Tooltip
      content={terminationReason}
      fixed={true}
      isFormClass={false}
      hasWrapper={false}
      position={'left'}
    />
  ) : null;
};

GuardianActions.propTypes = {
  columnProps: PropTypes.object,
};

export default GuardianActions;
